
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"20","cy":"20","r":"20","fill":"#EB5757"}}),_c('path',{attrs:{"d":"M28.3 31h-7.43c-1.624 0-2.57-1.832-1.632-3.157l3.864-5.449a2 2 0 013.305.062l3.567 5.449c.87 1.33-.084 3.095-1.673 3.095z","stroke":"#fff","stroke-width":"1.5","stroke-linecap":"round"}}),_c('path',{attrs:{"d":"M24.253 27.814L24 25h1l-.253 2.814h-.494zM24.046 29v-.789h.909V29h-.91z","fill":"#fff"}}),_c('path',{attrs:{"d":"M18.526 24H12a2 2 0 01-2-2v-8a2 2 0 012-2h14a2 2 0 012 2v5.846","stroke":"#fff","stroke-width":"1.5","stroke-linecap":"round"}}),_c('path',{attrs:{"d":"M11 13l7.392 4.363a2 2 0 002.123-.056L27 13","stroke":"#fff","stroke-width":"1.5","stroke-linecap":"round"}})])
          )
        }
      }
    